import catalogDocument from "../../generated/catalog.json";
import type { CommunityCatalogView } from "../types.js";

// The core community-catalog CLI validates this document before Vite or
// TypeScript runs. These interfaces are view types, never a second validator.
export const catalog = catalogDocument as CommunityCatalogView;

export function findTheme(themeId: string) {
  return catalog.themes.find(({ id }) => id === themeId);
}

export function findVersion(themeId: string, version: string) {
  return findTheme(themeId)?.versions.find((entry) => entry.version === version);
}
